// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Contact from "./contact.js"

const modelClassData = {
  "attributes": {
    "child_id": {
      "column": {
        "default": null,
        "name": "child_id",
        "null": false,
        "type": "uuid"
      },
      "name": "child_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "parent_id": {
      "column": {
        "default": null,
        "name": "parent_id",
        "null": false,
        "type": "uuid"
      },
      "name": "parent_id",
      "selected_by_default": null,
      "translated": null
    },
    "relationship_type": {
      "column": {
        "default": null,
        "name": "relationship_type",
        "null": false,
        "type": "string"
      },
      "name": "relationship_type",
      "selected_by_default": null,
      "translated": null
    },
    "translated_relationship_type": {
      "column": null,
      "name": "translated_relationship_type",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ContactRelationship",
  "collectionKey": "contact_relationships",
  "collectionName": "contact_relationships",
  "i18nKey": "contact_relationship",
  "camelizedLower": "contactRelationship",
  "name": "ContactRelationship",
  "nameDasherized": "contact-relationship",
  "pluralName": "contact_relationships",
  "ransackable_associations": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "child",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "parent",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "SchoolYear",
      "collectionName": "school_years",
      "foreignKey": "contact_relationship_id",
      "name": "school_year",
      "macro": "has_one",
      "resource_name": "SchoolYear",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "child_id",
      "column": {
        "default": null,
        "name": "child_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "handled_by_system",
      "column": {
        "default": false,
        "name": "handled_by_system",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_child_id",
      "column": {
        "default": null,
        "name": "old_child_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_parent_id",
      "column": {
        "default": null,
        "name": "old_parent_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "parent_id",
      "column": {
        "default": null,
        "name": "parent_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "relationship_type",
      "column": {
        "default": null,
        "name": "relationship_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "no_children_with_disabled_active_code_or_null"
    },
    {
      "name": "no_parents_with_disabled_active_code_or_null"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "child",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "parent",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    }
  ],
  "paramKey": "contact_relationship",
  "primaryKey": "id"
}

/** Frontend model for ContactRelationship. */
export default class ContactRelationship extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  childId() {
    return this.readAttributeUnderscore("child_id")
  }

  /** @returns {boolean} */
  hasChildId() {
    const value = this.childId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  parentId() {
    return this.readAttributeUnderscore("parent_id")
  }

  /** @returns {boolean} */
  hasParentId() {
    const value = this.parentId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  relationshipType() {
    return this.readAttributeUnderscore("relationship_type")
  }

  /** @returns {boolean} */
  hasRelationshipType() {
    const value = this.relationshipType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedRelationshipType() {
    return this.readAttributeUnderscore("translated_relationship_type")
  }

  /** @returns {boolean} */
  hasTranslatedRelationshipType() {
    const value = this.translatedRelationshipType()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static adminCreate(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "admin_create",
        collectionName: "contact_relationships",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  adminDestroy(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "admin_destroy",
        primaryKey: this.primaryKey(),
        collectionName: "contact_relationships",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./contact.js").default | null} */
  child() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "child"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadChild() {
    if (!("childId" in this)) throw new Error("Foreign key method wasn't defined: childId")

    const id = this.childId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "child",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureChildLoaded() {
    return this.ensureAssociationLoaded("child")
  }

  /** @returns {import("./contact.js").default | null} */
  parent() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "parent"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadParent() {
    if (!("parentId" in this)) throw new Error("Foreign key method wasn't defined: parentId")

    const id = this.parentId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "parent",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureParentLoaded() {
    return this.ensureAssociationLoaded("parent")
  }
}
